import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { CheckCircle, ArrowRight } from 'lucide-react';

import API from '../utils/api';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const BillingSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState('loading');
  const [plan, setPlan] = useState(null);
  
  useEffect(() => {
    verifyPayment();
  }, []);
  
  const verifyPayment = async () => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      setStatus('error');
      return;
    }
    
    try {
      const { data } = await axios.get(
        `${API}/billing/checkout-status/${sessionId}`,
        { withCredentials: true }
      );
      
      if (data.payment_status === 'paid') {
        setStatus('success');
        setPlan(data.plan || 'premium');
        await checkAuth();
      } else {
        setStatus('pending');
      }
    } catch (error) {
      console.error('Payment verification error:', error);
      setStatus('error');
    }
  };
  
  if (status === 'loading' || status === 'pending') {
    return (
      <div className="min-h-screen bg-[#F6F7FC] flex items-center justify-center p-6">
        <div className="text-center">
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-[#2D2560] border-r-transparent mb-4"></div>
          <p className="text-white/60">Verifying your payment...</p>
        </div>
      </div>
    );
  }
  
  if (status === 'error') {
    return (
      <div className="min-h-screen bg-[#F6F7FC] flex items-center justify-center p-6">
        <div className="max-w-md w-full card-surface p-8 text-center">
          <div className="w-16 h-16 bg-[#EF4444]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">⚠️</span>
          </div>
          <h2 className="text-2xl font-bold mb-2">Payment Verification Failed</h2>
          <p className="text-white/60 mb-6">We couldn't verify your payment. Please contact support.</p>
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-gradient-to-r from-[#2D2560] to-[#5A4E9E] text-white hover:opacity-90 font-semibold rounded-lg py-3 transition-opacity"
          >
            Return to Dashboard
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-[#F6F7FC] flex items-center justify-center p-6">
      <div className="max-w-md w-full card-surface p-8 text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_coparent-guide/artifacts/n6fsw9wd_8cd80fad-2083-40cb-bcec-817c0a21db6f.png"
          alt="Parentum"
          className="h-14 object-contain mx-auto mb-6"
          data-testid="checkout-logo"
        />
        <div className="w-16 h-16 bg-[#10B981]/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="w-10 h-10 text-[#10B981]" />
        </div>
        
        <h2 className="text-2xl font-bold mb-2">Welcome to {plan?.charAt(0).toUpperCase() + plan?.slice(1)}!</h2>
        <p className="text-white/60 mb-6">
          Your subscription is now active. You have full access to all features.
        </p>
        
        <button
          onClick={() => navigate('/dashboard')}
          className="w-full bg-gradient-to-r from-[#2D2560] to-[#5A4E9E] text-white hover:opacity-90 font-semibold rounded-lg py-3 transition-opacity flex items-center justify-center gap-2"
          data-testid="goto-dashboard-button"
        >
          Go to Dashboard
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default BillingSuccess;
